import { createReducer } from 'typesafe-actions';

import { ISearchState, TSearchAction, SearchActionTypes } from '@/store/types/search.types';

const initialState: ISearchState = {
  isLoading: false,
};

export const searchReducer = createReducer<ISearchState, TSearchAction>(initialState)
  .handleType(SearchActionTypes.SEARCH, (state) => {
    return {
      ...state,
      isLoading: true,
      error: undefined,
    };
  })

  .handleType(SearchActionTypes.SEARCH_SUCCESS, (state, action) => {
    const { type, ...rest } = action;

    return {
      ...state,
      ...rest,
      isLoading: false,
      error: undefined,
    };
  })

  .handleType(SearchActionTypes.SEARCH_FAIL, (state, action) => {
    return {
      ...state,
      isLoading: false,
      error: action.error,
    };
  })

  .handleType(SearchActionTypes.SEARCH_USERS, (state) => {
    return {
      ...state,
      isLoading: true,
      error: undefined,
    };
  })

  .handleType(SearchActionTypes.SEARCH_USERS_SUCCESS, (state, action) => {
    return {
      ...state,
      paginateUsers: action.paginateUsers,
      isLoading: false,
      error: undefined,
    };
  })

  .handleType(SearchActionTypes.SEARCH_USERS_FAIL, (state, action) => {
    return {
      ...state,
      isLoading: false,
      error: action.error,
    };
  });
